import { getRelationFieldNames } from '@/requests/instanceMapper';
import {
  ContractCancellationConfigurationConfig,
  type ContractCancellationConfiguration,
} from '@pigello/pigello-matrix';
import type { RelationFieldProps } from './types';
import { cn } from '@/lib/cn';

export const ContractCancellationConfigurationItem: RelationFieldProps<ContractCancellationConfiguration> =
  {
    nested: getRelationFieldNames(ContractCancellationConfigurationConfig),
    renderItem: (item, isRelationField) => {
      return {
        title: item.title ?? '',
        descriptionItems: (
          <div
            className={cn(
              'flex w-full items-center',
              isRelationField && 'justify-between'
            )}
          >
            <span>{item.customId ?? 'Inget objekts-id angivet'}</span>
          </div>
        ),
      };
    },
  };
